import React from "react";
import "../styles/footer.css";
import { Link } from "react-router-dom";
import { FiPhone } from "react-icons/fi";
import { FiMapPin } from "react-icons/fi";
import { FiMail } from "react-icons/fi";

export default function Footer() {
  return (
    <footer className="site-footer">
  <div className="footer-top">
    <div className="footer-col footer-brand">
      <div className="footer-logo-row">
        <a href="/">
        <img className="footer-logo" src="/images/logo_footer1.png" alt="PV" />
        </a>
        {/* <span className="brand-text">PracVerse</span> */}
      </div>

      <p className="footer-desc">
        Empowering the next generation through innovative drone education programs that combine STEM learning with real-world applications.
      </p>

      <div className="footer-social">
        <a
              href="https://www.instagram.com/pracverse"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* Instagram SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 
                  2.243 5 5 5h10c2.757 0 5-2.243 
                  5-5V7c0-2.757-2.243-5-5-5H7zm10 
                  2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 
                  3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 
                  1.346-3 3-3h10zm-5 3a5 5 0 100 10 
                  5 5 0 000-10zm0 2a3 3 0 110 6 
                  3 3 0 010-6zm4.5-.75a.75.75 
                  0 100 1.5.75.75 0 000-1.5z"/>
              </svg>
            </a>

            <a
              href="https://www.linkedin.com/company/pracverse"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* LinkedIn SVG */}
              
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-linkedin"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect width="4" height="12" x="2" y="9" />
                <circle cx="4" cy="4" r="2" />
              </svg>

            </a>
            
        {/* <a href="#" aria-label="LinkedIn" className="social-icon">ICON<A> */}
        {/* <a href="#" aria-label="Twitter" className="social-icon">ICON<a> */}
        {/* <a href="#" aria-label="YouTube" className="social-icon">ICON<a> */}
      </div>
    </div>

    <div className="footer-col footer-links">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="/courses">Our Courses</a></li>
        <li><a href="/events">Events</a></li>
        <li><a href="/partnerships">Partnerships</a></li>
        <li><a href="/testimonials">Testimonials</a></li>
        <li><a href="/about">About Us</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </div>


    <div className="footer-col footer-programs">
      <h4>Programs</h4>
      <ul>
        <li>
          <Link to="/courses?category=School">For Schools</Link>
        </li>
        <li>
          <Link to="/courses?category=College">For Colleges</Link>
        </li>
        <li>
          <Link to="/courses?category=NGO">For NGOs</Link>
        </li>
        <li>
          <Link to="/courses?category=Corporate">For Corporates</Link>
        </li>
      </ul>
    </div>

    <div className="footer-col footer-contact">
      <h4>Contact Info</h4>
      <div className="contact-row">
        <span className="contact-icon"><FiMail /></span>
        <div>
          <a href="mailto:contact@pracverse.com">contact@pracverse.com</a><br/>
          {/* <a href="mailto:connect@pracverse.com">connect@pracverse.com</a> */}
        </div>
      </div>

      <div className="contact-row">
        <span className="contact-icon"><FiPhone /></span>
         
        <div>
          <div>+91 7738700773</div>
          <div>+91 9004802817</div>
        </div>
      </div>

      <div className="contact-row">
        <span className="contact-icon"><FiMapPin /> </span>
        <div>
          A321, Royal Palms, <br/>
            Goregaon East, MUMBAI, 400065
        </div>
      </div>
    </div>
  </div>

  <div className="footer-divider" />

  <div className="footer-bottom">
    <div className="copyright">© 2025 PracVerse. All rights reserved.</div>
    <div className="policy-links">
      {/* <a href="/privacy">Privacy Policy</a>
      <a href="/terms">Terms of Service</a>
      <a href="/cookies">Cookie Policy</a> */}
      <a href="/privacy-policy">Privacy Policy</a>
<a href="/terms-of-service">Terms of Service</a>
<a href="/cookie-policy">Cookie Policy</a>

    </div>
  </div>
</footer>

  );
}
